import { render, staticRenderFns } from "./2_ImagemJornalzinho.vue?vue&type=template&id=2cb480bd&"
import script from "./2_ImagemJornalzinho.vue?vue&type=script&lang=js&"
export * from "./2_ImagemJornalzinho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports